import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import { changeStatus, getUsers } from "../../../services/academicService";
import ForgetUserPassword from "../../components/ForgetUserPassword";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Name", sortingVale: "title" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Mobile No", sortingVale: "phone" },
  // { heading: "Effective Dt", sortingVale: "type" },
  { heading: "Role", sortingVale: "subject" },
  { heading: "Permission", sortingVale: "department" },
  { heading: "Consider Staff", sortingVale: "staffConsider" },
  { heading: "Status", sortingVale: "status" },
  { heading: "Action", sortingVale: "action" },
];

const Users = () => {
  const [forgetModal, setForgetModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);

  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);

  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  async function fetchUserData({ page, size, search }) {
    setLoading(true);
    try {
      const res = await getUsers(page, size, search);
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever page/size/search changes
  useEffect(() => {
    fetchUserData({ page, size, search });
  }, [page, size, search]);

  function SotingData(name) {
    const sortedPeople = [...userData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "email":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "landLine":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.landLine || "").localeCompare(b.landLine || "")
            : (b.landLine || "").localeCompare(a.landLine || ""),
        );
        break;

      case "phone":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.phone || "").localeCompare(b.phone || "")
            : (b.phone || "").localeCompare(a.phone || ""),
        );
        break;

      default:
        break;
    }
    setUserData(sortedPeople);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  const currentStart = totalElements === 0 ? 0 : page * size + 1;

  async function handleChangeStatus() {
    if (!selectedRow) return;

    const isActive = selectedRow?.status === "ACTIVE";
    const action = isActive ? "Deactivate" : "Activate";
    const confirmColor = isActive ? "#c03221" : "#28a745"; // red or green

    // Ask for confirmation first
    const result = await Swal.fire({
      title: `Are you sure?`,
      text: `You are about to ${action.toLowerCase()} this user.`,
      icon: "warning",
      showCancelButton: true,
      backdrop: `rgba(60,60,60,0.8)`,
      confirmButtonText: `Yes, ${action} it!`,
      confirmButtonColor: confirmColor,
    });

    if (result.isConfirmed) {
      try {
        const data = await changeStatus(selectedRow?.user?.id);

        console.log("Change status response:", data);

        if (data) {
          fetchUserData({ page, size, search });
          console.log("Status changed successfully", data);
          toast.success("User status changed successfully", {
            position: "top-right",
            autoClose: 1000,
          });
        }
      } catch (error) {
        console.error("Error changing user status:", error);
        toast.error("Failed to update user status", {
          position: "top-right",
          autoClose: 1000,
        });
      }
    }
  }

  return (
    <>
      <PageTitle activeMenu={"All Users"} motherMenu={"Users"} />
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">All User List</h4>
                    <Link to={"/admin/add-users"} className="btn btn-primary">
                      + Add New
                    </Link>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="dataTables_wrapper no-footer">
                        <div className="justify-content-between d-sm-flex">
                          {/* PAGE SIZE DROPDOWN */}
                          <div className="dataTables_length">
                            <label className="d-flex align-items-center">
                              Show
                              <Dropdown className="search-drop ms-2 me-2">
                                <Dropdown.Toggle
                                  as="div"
                                  className="search-drop-btn"
                                >
                                  {size}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {[10, 20, 30].map((val) => (
                                    <Dropdown.Item
                                      key={val}
                                      onClick={() => {
                                        setSize(val);
                                        setPage(0);
                                      }}
                                    >
                                      {val}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                              entries
                            </label>
                          </div>

                          {/* SEARCH */}
                          <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                value={search}
                                onChange={handleSearchChange}
                              />
                            </label>
                          </div>
                        </div>

                        {/* TABLE */}
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    if (item.sortingVale === "action") return;
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                  style={
                                    item.sortingVale !== "action"
                                      ? { cursor: "pointer" }
                                      : {}
                                  }
                                >
                                  {item.heading}
                                  {item.sortingVale !== "action" && (
                                    <span>
                                      {ind !== iconData.ind && (
                                        <i
                                          className="fa fa-sort ms-2 fs-12"
                                          style={{ opacity: "0.3" }}
                                        />
                                      )}
                                      {ind === iconData.ind &&
                                        (iconData.complete ? (
                                          <i
                                            className="fa fa-arrow-down ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-arrow-up ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ))}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {!loading &&
                              userData.map((data, ind) => (
                                <tr key={ind}>
                                  <td>{ind + 1}</td>
                                  <td>{data.user.name}</td>
                                  <td>{data.user.email}</td>
                                  <td>{data.user.phone}</td>
                                  <td>{data.admin ? "Admin" : "User"}</td>
                                  <td>{data.tenantRole.name}</td>
                                  <td>{data.staffConsider ? "Yes" : "No"}</td>

                                  {/* <td>{data.user.effectiveDt}</td> */}
                                  <td>{data.status}</td>
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      <Link
                                        to="/admin/add-users"
                                        state={{ user: data, mode: "edit" }}
                                        className="btn btn-s sharp btn-primary"
                                      >
                                        <i className="fa fa-pencil" />
                                      </Link>
                                      <Dropdown>
                                        <Dropdown.Toggle
                                          variant="success"
                                          className="light sharp i-false"
                                        >
                                          {svg1}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                          <Dropdown.Item
                                            onClick={() => {
                                              setSelectedRow(data);
                                              handleChangeStatus();
                                            }}
                                          >
                                            Change Status
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            onClick={() => {
                                              setSelectedUser(data);
                                              setForgetModal(true);
                                            }}
                                          >
                                            Reset Password
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              ))}

                            {loading && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {!loading && userData.length === 0 && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {/* PAGINATION FOOTER */}
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            <span>
                              Page{" "}
                              <strong>
                                {page + 1} of {totalPages}
                              </strong>
                            </span>
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                            <Link
                              className={`paginate_button previous ${
                                page === 0 ? "disabled" : ""
                              }`}
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                if (page > 0) setPage(page - 1);
                              }}
                            >
                              Previous
                            </Link>

                            <Link
                              className={`paginate_button next ${
                                page + 1 >= totalPages ? "disabled" : ""
                              }`}
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                if (page + 1 < totalPages) setPage(page + 1);
                              }}
                            >
                              Next
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>

              {/* GRID VIEW */}
              <Tab.Pane eventKey="Grid" className="col-lg-12">
                <div className="row">
                  {userData?.map((item, ind) => (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12"
                      key={ind}
                    >
                      <div className="card card-profile">
                        <div className="card-header justify-content-end pb-0 border-0">
                          <Dropdown>
                            <Dropdown.Toggle
                              as="button"
                              className="btn btn-link i-false"
                              type="button"
                            >
                              <span className="dropdown-dots fs--1"></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="dropdown-menu dropdown-menu-right border py-0"
                            >
                              <div className="py-2">
                                <Link
                                  to="/admin/add-users"
                                  state={{ user: item, mode: "edit" }}
                                  className="dropdown-item"
                                >
                                  Edit
                                </Link>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="card-body pt-2">
                          <div className="text-center">
                            <div className="profile-photo">
                              <img
                                src={IMAGES?.smallpic2}
                                width="100"
                                className="img-fluid rounded-circle"
                                alt=""
                              />
                            </div>
                            <h3 className="mt-4 mb-1">{item?.user?.name}</h3>
                            <p className="text-muted">
                              {item.admin ? "Admin" : "User"}
                            </p>
                            <ul className="list-group mb-3 list-group-flush">
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Email:</span>
                                <span className="mb-0">
                                  {item?.user?.email}
                                </span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Phone:</span>
                                <span>{item?.user?.phone}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Permission:</span>
                                <span>{item?.tenantRole?.name}</span>
                              </li>
                            </ul>

                            {/* <Link
                              to="/admin/about-user"
                              state={{ user: item }}
                              className="btn btn-outline-primary btn-rounded mt-3 px-4"
                            >
                              Read More
                            </Link> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {loading && (
                    <div className="col-12 text-center my-3">Loading...</div>
                  )}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>

      <ForgetUserPassword
        show={forgetModal}
        onClose={() => setForgetModal(false)}
        userData={selectedUser}
      />
    </>
  );
};

export default Users;
